(function () {
  'use strict';
  const focusable = 'button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex="0"]';
  const visibleControls = root => Array.from(root.querySelectorAll(focusable)).filter(el => el.getClientRects().length && !el.closest('[hidden]'));

  // Existing overlays keep their own open/close animations; add keyboard containment and return focus.
  document.querySelectorAll('.krhu-sizechart, #krhuPopup, #CartDrawer').forEach(root => {
    let open = false;
    let returnTo = null;
    const isOpen = () => root.id === 'CartDrawer' ? root.classList.contains('open') :
      root.classList.contains('krhu-sizechart') ? root.classList.contains('is-open') : !root.hidden;
    const sync = () => {
      const next = isOpen();
      if (next === open) return;
      open = next;
      if (open) {
        returnTo = document.activeElement;
        const first = visibleControls(root)[0];
        if (first) first.focus({ preventScroll: true });
      } else if (returnTo && returnTo.isConnected && !root.contains(returnTo)) {
        returnTo.focus({ preventScroll: true });
      }
    };
    new MutationObserver(sync).observe(root, { attributes: true, attributeFilter: ['class', 'hidden'] });
    root.addEventListener('keydown', event => {
      if (!open || event.key !== 'Tab') return;
      const controls = visibleControls(root);
      const first = controls[0], last = controls[controls.length - 1];
      if (!first) { event.preventDefault(); return; }
      if (event.shiftKey && (document.activeElement === first || !controls.includes(document.activeElement))) {
        event.preventDefault(); last.focus();
      } else if (!event.shiftKey && (document.activeElement === last || !controls.includes(document.activeElement))) {
        event.preventDefault(); first.focus();
      }
    });
    sync();
  });

  document.querySelectorAll('.figureImg img, .product-list img, .product-list__product img').forEach(img => {
    if (img.complete) return;
    img.classList.add('krhu-image-pending');
    img.addEventListener('load', () => {
      img.classList.remove('krhu-image-pending');
      if (!img.closest('.figureImg')) img.classList.add('krhu-image-arrived');
    }, { once: true });
    img.addEventListener('error', () => img.classList.remove('krhu-image-pending'), { once: true });
  });

  const gallery = document.querySelector('.figureImg');
  if (!gallery || typeof HTMLDialogElement === 'undefined') return;
  const images = Array.from(gallery.querySelectorAll('img.product__item-img'));
  if (!images.length) return;
  const viewer = document.createElement('dialog');
  viewer.className = 'krhu-viewer';
  viewer.setAttribute('aria-label', 'Product images');
  const bar = document.createElement('div'); bar.className = 'krhu-viewer__bar';
  const count = document.createElement('span'); count.className = 'krhu-viewer__count'; count.setAttribute('role', 'status');
  const stage = document.createElement('div'); stage.className = 'krhu-viewer__stage';
  const photo = document.createElement('img'); photo.draggable = false;
  stage.append(photo);
  const controls = document.createElement('div'); controls.className = 'krhu-viewer__controls';
  function button(label, symbol, parent, action) {
    const b = document.createElement('button'); b.type = 'button'; b.title = label;
    b.setAttribute('aria-label', label); b.textContent = symbol;
    b.addEventListener('click', action); parent.append(b); return b;
  }
  bar.append(count);
  button('Close image viewer', '\u00d7', bar, () => viewer.close());
  let index = 0, scale = 1, x = 0, y = 0, origin = null, oldOverflow = '';
  const pointers = new Map();
  let start = null, moved = false, pinched = false;
  function paint() {
    const rect = stage.getBoundingClientRect();
    const limitX = rect.width * (scale - 1) / 2;
    const limitY = rect.height * (scale - 1) / 2;
    x = Math.max(-limitX, Math.min(limitX, x));
    y = Math.max(-limitY, Math.min(limitY, y));
    photo.style.transform = 'translate(' + x + 'px,' + y + 'px) scale(' + scale + ')';
  }
  function show(i) {
    index = (i + images.length) % images.length;
    photo.src = images[index].getAttribute('data-full-src') || images[index].currentSrc || images[index].src;
    photo.alt = images[index].alt || 'Product image ' + (index + 1);
    count.textContent = (index + 1) + ' / ' + images.length;
    scale = 1; x = 0; y = 0; paint();
  }
  const previous = button('Previous image', '\u2190', controls, () => show(index - 1));
  button('Zoom out', '\u2212', controls, () => { scale = Math.max(1, scale - 0.5); paint(); });
  button('Zoom in', '+', controls, () => { scale = Math.min(3, scale + 0.5); paint(); });
  const next = button('Next image', '\u2192', controls, () => show(index + 1));
  previous.hidden = next.hidden = images.length < 2;
  viewer.append(bar, stage, controls); document.body.append(viewer);
  function open(img) {
    origin = img; oldOverflow = document.body.style.overflow;
    viewer.showModal(); document.body.style.overflow = 'hidden'; show(images.indexOf(img));
  }
  viewer.addEventListener('close', () => {
    document.body.style.overflow = oldOverflow; pointers.clear();
    if (origin && origin.isConnected) origin.focus({ preventScroll: true });
  });
  viewer.addEventListener('keydown', event => {
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      event.preventDefault(); show(index + (event.key === 'ArrowLeft' ? -1 : 1));
    }
  });
  let tapStart = null;
  gallery.addEventListener('pointerdown', event => { tapStart = { x: event.clientX, y: event.clientY, scroll: gallery.scrollLeft }; }, { passive: true });
  images.forEach((img, i) => {
    img.tabIndex = 0; img.setAttribute('role', 'button');
    img.setAttribute('aria-label', 'Inspect ' + (img.alt || 'product') + ', image ' + (i + 1));
    img.setAttribute('aria-haspopup', 'dialog');
    img.addEventListener('click', event => {
      if (tapStart && (Math.hypot(event.clientX - tapStart.x, event.clientY - tapStart.y) > 12 || Math.abs(gallery.scrollLeft - tapStart.scroll) > 12)) return;
      open(img);
    });
    img.addEventListener('keydown', event => {
      if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); open(img); }
    });
  });
  function distance(points) { return Math.hypot(points[0].x - points[1].x, points[0].y - points[1].y); }
  stage.addEventListener('pointerdown', event => {
    if (event.button && event.pointerType === 'mouse') return;
    stage.setPointerCapture(event.pointerId);
    pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
    if (pointers.size === 1) { start = { x: event.clientX, y: event.clientY }; moved = false; pinched = false; }
    else pinched = true;
  });
  stage.addEventListener('pointermove', event => {
    if (!pointers.has(event.pointerId)) return;
    const before = Array.from(pointers.values());
    const last = pointers.get(event.pointerId);
    pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
    if (pointers.size === 2) {
      const after = Array.from(pointers.values());
      const oldScale = scale;
      scale = Math.max(1, Math.min(3, scale * distance(after) / Math.max(1, distance(before))));
      x *= scale / oldScale; y *= scale / oldScale;
      moved = true; paint();
    } else if (scale > 1) {
      x += event.clientX - last.x; y += event.clientY - last.y; paint();
    }
    if (start && Math.hypot(event.clientX - start.x, event.clientY - start.y) > 12) moved = true;
  });
  function end(event) {
    if (!pointers.has(event.pointerId)) return;
    pointers.delete(event.pointerId);
    if (event.type === 'pointerup' && !pointers.size && !pinched && scale === 1 && moved && start) {
      const dx = event.clientX - start.x, dy = event.clientY - start.y;
      if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy)) show(index + (dx < 0 ? 1 : -1));
    }
  }
  stage.addEventListener('pointerup', end);
  stage.addEventListener('pointercancel', end);
  stage.addEventListener('dblclick', () => { scale = scale > 1 ? 1 : 2; x = y = 0; paint(); });
  window.addEventListener('resize', () => { if (viewer.open) paint(); });
})();
